// extracted by mini-css-extract-plugin
module.exports = {"container":"mI_H3H","body":"c8hpR7","title":"mod0-Q","name":"iVF9dJ","subTitle":"L6t2P8","link":"vltZ_g","brand":"GZgDzR"};